<div class="play-details product-detail-container">
  <div class="product-detail-content" #productdetailcontent>
    <app-product-detail-intro id="productDetailIntro"
                              [pack]="pack"
                              [play]="isPlay()"
                              [showFaqs]="true"
                              [showQrTile]="pack.subscribed"
                              [superiorSubscribedPack]="superiorSubscribedPack"
                              [titleKey]="'eos-tv-shop-ii.title.play-details-intro'"
                              [descriptionKey]="'eos-tv-shop-ii.text.play-details-intro'"
                              (emitOrderProduct)="goToOptionsPage()">
    </app-product-detail-intro>
    <app-product-detail-info class="productDetailEntertainment"
                             [columns2]="false"
                             [omapiId]="omapiId"
                             [play]="isPlay()"
                             [superiorSubscribedPack]="superiorSubscribedPack"
                             [titleKey]="'eos-tv-shop-ii.title.play-features'"
                             [descriptionKey]="'eos-tv-shop-ii.text.play-features'"
                             (emitOrderProduct)="goToOptionsPage()">
    </app-product-detail-info>
   </div>
  <app-arrow id="arrow_direction"></app-arrow>
  <app-ordering-modal-manager [order]="order" #orderModal></app-ordering-modal-manager>
</div>

